/**
 * UserDashboardPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  Statistic,
} from 'components';
import { Button, DatePicker, Input, Radio, Select, Tooltip } from 'antd';
import moment from 'moment';
import { QuestionCircleOutlined } from '@ant-design/icons';

const UserDashboardPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '회원구분',
      form: [
        {
          input: (
            <Radio.Group value={'회원'}>
              <Radio value={'회원'}>회원</Radio>
              <Radio value={'비회원'}>비회원</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: '검색어',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'아이디'}
              options={[
                { label: '아이디', value: '아이디' },
                { label: '회원명', value: '회원명' },
                { label: '전화번호', value: '전화번호' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <Input
              size="large"
              placeholder="검색어를 입력해주세요"
              style={{ ...styles.form.input.large }}
            />
          ),
        },
      ],
    },
    {
      label: '회원등급',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[
                { label: '전체', value: '전체' },
                { label: 'VVIP', value: 'VVIP' },
                { label: 'VIP', value: 'VIP' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
      ],
    },
    {
      label: '회원가입일',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '나이',
      form: [
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.large, marginRight: 0 }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.large }}
              />
              <p style={{ ...styles.form.text }}>세</p>
            </>
          ),
        },
      ],
    },
    {
      label: '성별',
      form: [
        {
          input: (
            <Radio.Group value={'전체'}>
              <Radio value={'전체'}>전체</Radio>
              <Radio value={'남'}>남</Radio>
              <Radio value={'여'}>여</Radio>
            </Radio.Group>
          ),
        },
      ],
    },
    {
      label: (
        <>
          최근 구매건수{' '}
          <Tooltip
            title={
              <span>
                - 총 주문건수는 주문 상태와 관계 없이 주문한 금액의 합과 건수를
                의미합니다.
                <br />- 총 실주문건수는 취소된 주문을 제외한 주문건수를
                의미합니다.
              </span>
            }
          >
            <span style={{ paddingLeft: 5, color: 'var(--light-gray-color)' }}>
              <QuestionCircleOutlined />
            </span>
          </Tooltip>
        </>
      ),
      form: [
        {
          input: (
            <Select
              size="large"
              value={'총 주문건수'}
              options={[
                { label: '총 주문건수', value: '총 주문건수' },
                { label: '총 실주문건수', value: '총 실주문건수' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <Select
              size="large"
              placeholder="검색 기간 선택"
              options={[
                { label: '오늘', value: '오늘' },
                { label: '7일 이내', value: '7일 이내' },
                { label: '1개월 이내', value: '1개월 이내' },
                { label: '3개월 이내', value: '3개월 이내' },
                { label: '6개월 이내', value: '6개월 이내' },
                { label: '1년 이내', value: '1년 이내' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.large, marginRight: 0 }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.large }}
              />
              <p style={{ ...styles.form.text }}>건</p>
            </>
          ),
        },
      ],
    },
    {
      label: (
        <>
          최근 구매금액{' '}
          <Tooltip
            title={
              <span>
                - 총 주문금액은 주문 상태와 관계 없이 주문한 금액의 합과 건수를
                의미합니다.
                <br />- 총 실결제금액은 취소 건은 차감된 실제로 결제한 금액의
                합을 의미합니다.
              </span>
            }
          >
            <span style={{ paddingLeft: 5, color: 'var(--light-gray-color)' }}>
              <QuestionCircleOutlined />
            </span>
          </Tooltip>
        </>
      ),
      form: [
        {
          input: (
            <Select
              size="large"
              value={'총 결제금액'}
              options={[
                { label: '총 결제금액', value: '총 결제금액' },
                { label: '총 실결제금액', value: '총 실결제금액' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <Select
              size="large"
              placeholder="검색 기간 선택"
              options={[
                { label: '오늘', value: '오늘' },
                { label: '7일 이내', value: '7일 이내' },
                { label: '1개월 이내', value: '1개월 이내' },
                { label: '3개월 이내', value: '3개월 이내' },
                { label: '6개월 이내', value: '6개월 이내' },
                { label: '1년 이내', value: '1년 이내' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.large, marginRight: 0 }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <Input
                size="large"
                placeholder="숫자만 입력"
                style={{ ...styles.form.input.large }}
              />
              <p style={{ ...styles.form.text }}>원</p>
            </>
          ),
        },
      ],
    },
    {
      label: '사용여부',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[
                { label: '전체', value: '전체' },
                { label: 'VVIP', value: 'VVIP' },
                { label: 'VIP', value: 'VIP' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
      ],
    },
    {
      label: '주문일/결제완료일',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'주문일'}
              options={[
                { label: '주문일', value: '주문일' },
                { label: '결제완료일', value: '결제완료일' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '접속일',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  for (let i = 0; i < 100; i++) {
    newData.push({
      created_at: new Date(),
      name: `홍길동 ${i}`,
      account: `abcdefg${i}`,
      grade: 'VVIP',
      gender: 'M',
      age: 25,
      area: '부산광역시 어쩌고 저쩌고 이렇고 저렇고',
    });
  }

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>대시보드</Title>

          {/* 요약 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40, display: 'flex' }}
          >
            {[
              { title: '신규 회원', value: 777 },
              { title: '등급별 회원', value: 777 },
              { title: '탈퇴 회원', value: 777 },
              { title: '전체 회원', value: 777 },
              { title: '방문 회원', value: 777 },
            ].map((_item, _index) => (
              <div
                key={`${_item.label}-${_index}`}
                style={{
                  background: '#FFFFFF',
                  borderRadius: 4,
                  width: `calc(100% / 5)`,
                  marginRight: _index === 4 ? 0 : 4,
                  padding: 20,
                }}
              >
                <Statistic
                  title={_item.title}
                  value={_item.value}
                  suffix={'명'}
                  direction={'row'}
                  style={{ justifyContent: 'center' }}
                />
              </div>
            ))}
          </Content>
          {/* 요약 끝 */}

          {/* 검색필터 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40 }}
          >
            <ExpandableContainer borderRadius={4} padding={20}>
              {formItem.map((_item, _index) => (
                <div
                  key={`form_${_index}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 0px',
                  }}
                >
                  <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                    <label>{_item.label}</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {_item.form.map((_subitem, _subkey) => (
                      <React.Fragment key={`input_${_subkey}`}>
                        {_subitem.input}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </ExpandableContainer>

            {/* 검색/초기화 버튼 */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: 48,
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{ ...styles.button, background: 'var(--primary-color)' }}
              >
                검색
              </Button>
              <Button size="large" style={{ ...styles.button }}>
                초기화
              </Button>
            </div>
            {/* 검색/초기화 버튼 끝 */}
          </Content>
          {/* 검색필터 끝 */}

          {/* 검색결과 */}
          <Content maxWidth={'100%'} borderRadius={4} padding={20}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 20,
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <h4 style={{ fontSize: 14, fontWeight: 500, marginRight: 20 }}>
                  검색 결과 총 <span>0</span>건
                </h4>
                <Button size="large" style={{ marginRight: 8 }}>
                  SMS 전송
                </Button>
                <Button size="large" style={{ marginRight: 8 }}>
                  엑셀다운로드
                </Button>
              </div>
            </div>

            <Table
              data={newData}
              columns={[
                {
                  title: '이름',
                  key: 'name',
                },
                {
                  title: '아이디',
                  key: 'account',
                },
                {
                  title: '등급',
                  key: 'grade',
                },
                {
                  title: '성별',
                  key: 'gender',
                },
                {
                  title: '나이',
                  key: 'age',
                },
                {
                  title: '지역',
                  key: 'area',
                  width: 300,
                },
                {
                  title: '회원가입일',
                  key: 'created_at',
                  render: (item) => moment(item).format('YYYY-MM-DD'),
                },
              ]}
            />
          </Content>
          {/* 검색결과 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default UserDashboardPresenter;
